module.exports = __webpack_public_path__ + "static/images/4fb494a2af3369a05b884b01d4fe89d9.png";